
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-textarea-input-config",
})
export default class TextareaInputConfig extends ComponentConfigMixins {}
